const screenSize = {
	Desktop: "desktop",
	Tablet: "tablet",
	Mobile: "mobile",
};
let screenState = screenSize.Desktop;

function setScreenState() {
	if (window.innerWidth > 1020) {
		screenState = screenSize.Desktop;
	}
	if (window.innerWidth <= 1020) {
		screenState = screenSize.Tablet;
	}
	if (window.innerWidth <= 600) {
		screenState = screenSize.Mobile;
	}
}
setScreenState();

let menuOpen = false;
const fullPageMenu = function () {
	mobileMenuIcon.addEventListener("click", function () {
		OpenCloseMenu();
	});

	var fullPageMenuEle = document.getElementById("fullPageMenu");
	let backgroundOverlay = fullPageMenuEle.querySelector(".background-overlay");
	let slideOutContainer = fullPageMenuEle.querySelector(".full-page-menu__container");
	function OpenCloseMenu() {
		mobileMenuIcon.classList.toggle("open");
		document.documentElement.classList.toggle("freeze");

		if (menuOpen) {
			menuOpen = false;

			gsap.to(backgroundOverlay, 0.5, {
				opacity: 0,
				ease: Power1.easeInOut,
				onComplete: function () {
					fullPageMenuEle.classList.remove("show");
				},
			});
			// gsap.to(slideOutContainer, 0.5, {
			// 	x: "100%",
			// 	ease: Power1.easeInOut,
			// });
			gsap.to(slideOutContainer, 0.5, {
				opacity: 0,
				ease: Power1.easeInOut,
			});

			// let subElements = fullPageMenuEle.querySelectorAll('ul li');
			// for (let i = 0; i < subElements.length; i++) {
			//     const element = subElements[i];
			//     element.classList.remove('animate');
			// }
		} else {
			menuOpen = true;

			fullPageMenuEle.classList.add("show");

			fullPageMenuEle.focus();

			gsap.fromTo(
				backgroundOverlay,
				0.5,
				{
					opacity: 0,
				},
				{
					opacity: 1,
					ease: Power1.easeInOut,
				}
			);
			gsap.fromTo(
				slideOutContainer,
				0.5,
				{
					opacity: 0,
				},
				{
					opacity: 1,
					ease: Power1.easeInOut,
				}
			);
			// gsap.to(slideOutContainer, 0.5, {
			// 	x: "0%",
			// 	ease: Power1.easeInOut,
			// });

			// let delayTime = 150;
			// let subElements = fullPageMenuEle.querySelectorAll('.full-page-menu__container > div > ul > li');
			// for (let i = 0; i < subElements.length; i++) {
			//     const element = subElements[i];
			//
			//     setTimeout(function(){
			//         if(menuOpen){
			//             element.classList.add('animate');
			//         }
			//     }, delayTime);
			//     delayTime += 150;
			// }
		}
	}

	const menuItemsWithSubMenus = fullPageMenuEle.querySelectorAll(".menu-item-has-children");
	menuItemsWithSubMenus.forEach((item) => {
		const subMenu = item.querySelector(":scope > .sub-menu");
		subMenu.querySelectorAll("a").forEach((link) => {
			link.setAttribute("aria-hidden", true);
			link.setAttribute("tabindex", "-1");
		});

		const link = item.querySelector(":scope > a");
		link.addEventListener("click", function (e) {
			if (!link.classList.contains("opened")) {
				e.preventDefault();
			}
			subMenu.classList.toggle("show");
			link.classList.toggle("opened");

			if (subMenu.classList.contains("show")) {
				subMenu.querySelectorAll("a").forEach((link) => {
					link.setAttribute("aria-hidden", false);
					link.setAttribute("tabindex", "0");
				});
			} else {
				subMenu.querySelectorAll("a").forEach((link) => {
					link.setAttribute("aria-hidden", true);
					link.setAttribute("tabindex", "-1");
				});
			}
		});
	});
};
const mobileMenuIcon = document.getElementById("mobile-menu-icon");
if (mobileMenuIcon) {
	fullPageMenu();
}
// ---- SCROLL TO
const ScrollToHash = function () {
	let windowHash = window.location.hash;
	if (windowHash) {
		windowHash = windowHash.replace("#", "");
		let dest = document.getElementById(windowHash);
		
		if (dest) {
			let destElement = dest.getBoundingClientRect().top + document.documentElement.scrollTop;
			let offset = (window.innerHeight - destElement.height) / 2.5;
			
			ScrollToElement(destElement, -50, 0.7);
			// Remove hash from URL
			history.replaceState(null, null, window.location.pathname);
			
		}
	}
};

const GetAllScrollToElements = function () {
	for (let i = 0; i < allAnchorLinks.length; i++) {
		const element = allAnchorLinks[i];
		element.addEventListener("click", function (e) {
			e.preventDefault();
			let dest = element.getAttribute("href");
			if (dest) {
				let destElement =
					document.getElementById(dest.replace("#", "")).getBoundingClientRect().top +
					document.documentElement.scrollTop;
				let offset = (window.innerHeight - destElement.height) / 2.5;
				ScrollToElement(destElement, -100, 0.7);
				setTimeout(() => {
					history.replaceState(null, null, window.location.pathname);
				}, 100);
			}
		});
	}
};
const allAnchorLinks = document.querySelectorAll("a[href^='#']");
if (allAnchorLinks.length > 0) {
	GetAllScrollToElements();
}

const headerbutton = document.querySelectorAll("a");
if (headerbutton.length > 0) {
	GetAllScrollToElements();
}

const ScrollToElement = function (elementPosition, offset, duration) {
	elementPosition += offset;
	gsap.to(window, duration, {
		scrollTo: { y: elementPosition },
		ease: Power1.easeInOut,
	});
};
setTimeout(function () {
	ScrollToHash();
}, 300);

const accordions = document.querySelectorAll(".accordion");
const accordionFunctionality = function () {
	let currentOpenAccordion;
	accordions.forEach((item) => {
		let contentHeight = item.querySelector(".accordion__content .content-container").offsetHeight;
		item.querySelector(".accordion__content").style.height = contentHeight + "px";

		item.querySelector(".accordion__title").addEventListener("click", function () {
			if (currentOpenAccordion && currentOpenAccordion !== item) {
				currentOpenAccordion.classList.add("collapsed");
			}
			item.classList.toggle("collapsed");
			currentOpenAccordion = item;
		});
	});
};
if (accordions) {
	accordionFunctionality();
}



const openPopup = function (selector) {
	selector.classList.add("show");
	setTimeout(function () {
		selector.classList.add("animate");
	}, 0);
	document.body.classList.add("freeze");
	console.log("opening");
};
const closePopup = function (selector) {
	selector.classList.remove("animate");
	let videoContainer = selector.querySelector(".video-container");
	let iframe = selector.querySelector(".video-container iframe");
	let iframeHTML = "";
	if (iframe) {
		iframeHTML = videoContainer.innerHTML;
		videoContainer.innerHTML = "";
	}
	setTimeout(function () {
		selector.classList.remove("show");
		if (iframe) {
			videoContainer.innerHTML = iframeHTML;
		}
	}, 400);
	document.body.classList.remove("freeze");
	console.log("closing");
};

let popupOpenButtons = document.querySelectorAll(".open-popup");
for (const button of popupOpenButtons) {
	const popupId = button.dataset.button;
	const popup = document.querySelector('div[data-popup="' + popupId + '"]');
	button.addEventListener("click", function () {
		openPopup(popup);
	});
}

let popupCloseButtons = document.getElementsByClassName("close-popup");
for (let i = 0; i < popupCloseButtons.length; i++) {
	const element = popupCloseButtons[i];

	element.addEventListener("click", function () {
		closePopup(element.closest(".popup"));
	});
}

// RELLAX
if (document.querySelector(".rellax")) {
	var rellax = new Rellax(".rellax", {
		speed: -2,
	});
}
if (document.querySelector(".rellax--center")) {
	var rellax = new Rellax(".rellax--center", {
		speed: 1,
		center: true,
	});
}

// LAZY LOAD IFRAME
let lazyLoadIframes = document.querySelectorAll(".lazy-load--iframe");
if (lazyLoadIframes) {
	window.onload = function () {
		for (const iframe of lazyLoadIframes) {
			iframe.style.display = "block";
		}
	};
}

// ---- GOOGLE MAPS
// const GoogleMaps = function(){

//     var markers = document.getElementsByClassName("marker");

//     var args = {
//         zoom		: 15,
//         center		: new google.maps.LatLng(0, 0),
//         mapTypeId	: google.maps.MapTypeId.ROADMAP,
//         scrollwheel: false,
//         disableDefaultUI: true
//     }

//     var map = new google.maps.Map( mapEle, args);

//     map.markers = [];

//     for(var i = 0; i < markers.length; i++){
//         add_marker(markers[i],map);
//     }

//     center_map( map );
//     window.addEventListener('resize',function(){
//         google.maps.event.trigger(map, "resize");
//         center_map( map );
//     });

//     function add_marker( markerEle, map ) {
//         const latlng = new google.maps.LatLng( markerEle.getAttribute('data-lat'), markerEle.getAttribute('data-lng') );

//         //var mapIconURL = "https://" + window.location.hostname + '/wp-content/themes/AboveTheme/assets/img/map-marker.png'; //UPDATE THIS TO POINT TO THE MAP MARKER ICON

//         let icon = {
//             //url: mapIconURL,
//             scaledSize: new google.maps.Size(88,110),
//             origin: new google.maps.Point(0,0),
//             anchor: new google.maps.Point(35,60)
//         };
//         let marker = new google.maps.Marker({
//             position	: latlng,
//             map			: map,
//             //icon:     mapIconURL
//         });

//         map.markers.push( marker );

//         if( markerEle.html )
//         {
//             let infowindow = new google.maps.InfoWindow({
//                 content		: markerEle.html
//             });

//             google.maps.event.addListener(marker, 'click', function() {
//                 infowindow.open( map, marker );
//             });
//         }
//     }

//     function center_map( map ) {
//         let bounds = new google.maps.LatLngBounds();

//         for(let i = 0; i < map.markers.length; i++){
//             let marker = map.markers[i];
//             let latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

//             bounds.extend(latlng);
//         }

//         if( map.markers.length == 1 )
//         {
//             map.setCenter( bounds.getCenter() );
//             map.setZoom( 12 );
//         }
//         else
//         {
//             map.fitBounds( bounds );
//         }
//     }
// }
// const mapEle = document.getElementById("map");
// if(mapEle){
//     let googleMapsScript = document.createElement('script');
//     googleMapsScript.onload = function () {
//         GoogleMaps();
//     };
//     googleMapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBNss-Yq3NDNCDcQ0SvG0FlLEdNolh9a1E';

//     document.body.appendChild(googleMapsScript);
// }

// const activityReadMores = document.querySelectorAll('.activities__content .read-more');
// activityReadMores.forEach(item => {
//     item.addEventListener('click', function(){
//         item.previousElementSibling.classList.add('open');
//         item.classList.add('hidden');
//     })
// })
const tabs = document.querySelectorAll(".tabs");
const tabsFunctionality = function (tab) {
	const currentOpenTab = 0;
	let tabLabels = tab.querySelectorAll(".tabs__label");
	let tabBodies = tab.querySelectorAll(".tabs__tab");

	const setTabHeight = function (selectedTab) {
		let tabsBody = tab.querySelector(".tabs__body");
		if (tabsBody) {
			tab.querySelector(".tabs__body").style.height = selectedTab.offsetHeight + "px";
		}
	};

	tabLabels.forEach((item) => {
		item.addEventListener("click", function () {
			let id = item.dataset.id;

			tab.querySelector(".tabs__tab.active").classList.remove("active");
			tab.querySelector('.tabs__tab[data-id="' + id + '"]').classList.add("active");
			tab.querySelector(".tabs__label.active").classList.remove("active");
			this.classList.add("active");

			setTabHeight(tab.querySelector('.tabs__tab[data-id="' + id + '"]'));
		});
	});

	setTabHeight(tab.querySelector(".tabs__tab.active"));
};
for (const tab of tabs) {
	tabsFunctionality(tab);
}

let faqSection = document.querySelector(".faq");
let faqItems = document.querySelectorAll(".faq__item");
const filterFAQ = function (criteria) {
	for (item of document.querySelectorAll(".has-criteria")) {
		item.classList.remove("has-criteria");
	}

	if (criteria == "") {
		faqSection.classList.remove("filtered");

		// gsap.to(document.querySelector(".faq__topics"), 0.5, {
		// 	height: "auto",
		// 	ease: Power1.easeInOut,
		// });

		return;
	}

	faqSection.classList.add("filtered");
	// gsap.to(document.querySelector(".faq__topics"), 0.5, {
	// 	height: "0",
	// 	ease: Power1.easeInOut,
	// });

	let parentsWithMatchingCritera = [];
	const lowerCriteria = criteria.toLowerCase();

	for (const item of faqItems) {
		if (item.innerText.toLowerCase().indexOf(lowerCriteria) !== -1) {
			item.classList.add("has-criteria");

			let itemParent = item.closest(".tabs__tab");
			if (!parentsWithMatchingCritera.includes(itemParent)) {
				parentsWithMatchingCritera.push(itemParent);
			}
		}
	}
	for (const parent of parentsWithMatchingCritera) {
		parent.classList.add("has-criteria");
	}
};

let faqButton = document.querySelector("#faq-search-input");
if (faqButton) {

	faqButton.addEventListener("keyup", function (e) {
		
		e.preventDefault();
		if (e.keyCode === 13) {
			filterFAQ(document.getElementById("faq-search-input").value);
		}
		
	});
}

const resetFaqs = function () {
	for (item of document.querySelectorAll(".has-criteria")) {
		item.classList.remove("has-criteria");
	}
		document.querySelector(".faq").classList.remove("filtered");
};
let guideSearchReset = document.querySelector("#guide-search-reset");
if (guideSearchReset) {

	guideSearchReset.addEventListener("click", function (e) {
		resetFaqs();
		// e.preventDefault();
		// if (e.keyCode === 13) {
		// 	filterFAQ(document.getElementById("faq-search-input").value);
		// }
		
	});
}


document.addEventListener("DOMContentLoaded", function() {
	let tabs = document.querySelectorAll('.tab');
	let contents = document.querySelectorAll('.tab-content');
	tabs.forEach(tab => {
		tab.addEventListener('click', function() {
			tabs.forEach(t => t.classList.remove('active'));
			contents.forEach(c => c.classList.remove('active'));
			
			this.classList.add('active');
			document.getElementById(this.getAttribute('data-tab')).classList.add('active');
		});
	});
});


const accordion_items = document.querySelectorAll(".accordion-item");

const newAccordion = function () {
	const items = document.querySelectorAll(".accordion-item");
  
	items.forEach((item) => {
	  const header = item.querySelector(".accordion__title");
	  const content = item.querySelector(".accordion-content");
  
	  header.addEventListener("click", () => {
		const isActive = item.classList.contains("active");
  
		// Close all items
		items.forEach(i => {
		  i.classList.remove("active");
		  i.querySelector(".accordion-content").style.height = "0px";
		});
  
		// Open current if it was not already active
		if (!isActive) {
		  item.classList.add("active");
		  content.style.height = content.scrollHeight + "px";
		}
  
	  });
	});
  };
// for (const item of accordion_items) {
	newAccordion();
// }


